import { Button } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { useImpressionRef } from '@zep/logger/react';
interface QuizBankErrorStateProps {
  onRetry?: () => void;
  /** 이 화면이 실제로 보였을 때 1회. `quiz_bank_result_retry_click` 의 분모가 된다. */
  onImpress?: () => void;
}
const NOOP = () => {};
export const QuizBankErrorState = ({
  onRetry,
  onImpress
}: QuizBankErrorStateProps) => {
  const {
    t
  } = useTranslation(['build']);
  const impressionRef = useImpressionRef<HTMLDivElement>(onImpress ?? NOOP);
  return <div ref={impressionRef} className="flex size-full flex-col items-center justify-center gap-lg px-lg py-3xl" data-sentry-component="QuizBankErrorState" data-sentry-source-file="QuizBankErrorState.tsx">
      <div className="flex flex-col items-center gap-3xs">
        <h4 className="text-center text-heading-md-bold text-default">
          {t('build:quizBank.error.title')}
        </h4>
        <p className="text-center text-body-md-medium text-alternative">
          {t('build:quizBank.error.description')}
        </p>
      </div>

      {onRetry && <Button variant="outlined" intent="neutral" size="md" onClick={onRetry}>
          {t('build:quizBank.error.retry')}
        </Button>}
    </div>;
};